module.exports = __webpack_public_path__ + "static/img/founder15.28667242.png";